import React, { useState } from 'react';
import { Eye, EyeOff, Lock } from 'lucide-react';
import { api } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const TrocarSenhaObrigatoria = () => {
  const { user, logout, concluirTrocaSenha } = useAuth();
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [mostrar, setMostrar] = useState(false);
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const salvar = async (e) => {
    e.preventDefault();
    setErro('');
    if (novaSenha.length < 6) {
      setErro('A nova senha deve ter pelo menos 6 caracteres.');
      return;
    }
    if (novaSenha !== confirmacao) {
      setErro('As senhas não correspondem.');
      return;
    }
    setSalvando(true);
    try {
      const resposta = await api.put('/auth/trocar-senha-obrigatoria', {
        novaSenha,
        confirmacao
      });
      const atualizado = resposta.data?.data?.user || { ...user, trocar_senha: false };
      concluirTrocaSenha({ ...user, ...atualizado, trocar_senha: false });
    } catch (error) {
      setErro(error.response?.data?.message || 'Erro ao alterar a senha.');
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow p-6">
        <div className="flex items-center gap-2 mb-2">
          <Lock className="h-5 w-5 text-indigo-600" />
          <h1 className="text-xl font-semibold text-gray-900">Alterar senha</h1>
        </div>
        <p className="text-sm text-gray-600 mb-6">
          {user?.nome ? `${user.nome}, defina` : 'Defina'} uma nova senha para continuar.
        </p>
        <form onSubmit={salvar} className="space-y-4">
          <div className="relative">
            <input
              type={mostrar ? 'text' : 'password'}
              value={novaSenha}
              onChange={(e) => setNovaSenha(e.target.value)}
              placeholder="Nova senha"
              className="w-full border border-gray-300 rounded-md px-3 py-2 pr-10"
              autoComplete="new-password"
            />
            <button
              type="button"
              className="absolute inset-y-0 right-0 px-3 text-gray-500"
              onClick={() => setMostrar((v) => !v)}
            >
              {mostrar ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </div>
          <input
            type={mostrar ? 'text' : 'password'}
            value={confirmacao}
            onChange={(e) => setConfirmacao(e.target.value)}
            placeholder="Confirmar senha"
            className="w-full border border-gray-300 rounded-md px-3 py-2"
            autoComplete="new-password"
          />
          {erro && <p className="text-sm text-red-600">{erro}</p>}
          <button
            type="submit"
            disabled={salvando}
            className="w-full px-4 py-2 bg-indigo-600 text-white rounded-md disabled:opacity-60"
          >
            {salvando ? 'Salvando...' : 'Salvar e continuar'}
          </button>
          <button type="button" onClick={logout} className="w-full text-sm text-gray-600">
            Sair
          </button>
        </form>
      </div>
    </div>
  );
};

export default TrocarSenhaObrigatoria;
